import { ScrollableNav } from "../../scrollable-nav";

export const initScrollableNavigations = function() {
    const selector = `.${ScrollableNav.ELEMENT_CLASS}:not(.${ScrollableNav.INITIALIZATION_CLASS})`;
    const navElements = document.querySelectorAll(selector);
    for (const nav of [...navElements]) {
        new ScrollableNav(nav);
    }
}